(function () {
  window.FoxThemeSettings = window.FoxThemeSettings || {};
  const mobileCheck = window.matchMedia("screen and (max-width: 749px)");
  mobileCheck.addEventListener("change", (e) => {
    if (e.matches) {
      FoxThemeSettings.isMobile = true;
      document.dispatchEvent(new CustomEvent("matchMobile"));
    } else {
      FoxThemeSettings.isMobile = false;
      document.dispatchEvent(new CustomEvent("unmatchMobile"));
    }
  });
})();
function queryDomNodes(selectors = {}, context = document) {
  const domNodes = Object.entries(selectors).reduce((acc, [name, selector]) => {
    const findOne = typeof selector === "string";
    const queryMethod = findOne ? "querySelector" : "querySelectorAll";
    const sl = findOne ? selector : selector[0];

    acc[name] = context?.[queryMethod]?.(sl);
    if (!findOne && acc[name]) {
      acc[name] = [...acc[name]];
    }
    return acc;
  }, {});
  return domNodes;
}

function debounce(fn, wait) {
  let t;
  return (...args) => {
    clearTimeout(t);
    t = setTimeout(() => fn.apply(this, args), wait);
  };
}
class FResponsiveImage extends HTMLElement {
  get intersecting() {
    return this.hasAttribute("intersecting");
  }

  constructor() {
    super();
    this.img = this.querySelector("img");
    this.observerCallback = this.observerCallback.bind(this);
    this.loadImage = this.loadImage.bind(this);
    this.img.onload = this.onLoad.bind(this);
  }

  connectedCallback() {
    if ("IntersectionObserver" in window) this.initIntersectionObserver();
    else this.loadImage();
  }
  disconnectedCallback() {
    this.disconnectObserver();
  }
  loadImage() {
    this.setAttribute("intersecting", "true");
    this.img.width = this.clientWidth;
    this.img.height = this.clientHeight;
    this.img.sizes = this.clientWidth + "px";
  }
  onLoad() {
    this.removeAttribute("data-image-loading");
    this.img.classList.add("f-img-loaded");
  }
  observerCallback(entries, observer) {
    if (!entries[0].isIntersecting) return;
    observer.unobserve(this);
    this.loadImage();
  }
  initIntersectionObserver() {
    if (this.observer) return;
    const rootMargin = "10px";
    this.observer = new IntersectionObserver(this.observerCallback, {
      rootMargin,
    });
    this.observer.observe(this);
  }
  disconnectObserver() {
    if (!this.observer) return;
    this.observer.disconnect();
    this.observer = null;
    delete this.observer;
  }
}
customElements.define("f-responsive-image", FResponsiveImage);

class FSlideshow extends HTMLElement {
	static get observedAttributes() {
		return ['data-content-below', 'data-slide-height', 'data-slide-height-mobile', 'data-slide-radius']
	}

  constructor() {
    super();
  }

  connectedCallback() {
		this.elements = {
			images: this.querySelector(".f-slideshow__images"),
			contents: this.querySelector(".f-slideshow__contents"),
		};
		
		this.settings = {
			autorotate: this.dataset.autorotate === "true",
			contentBelow: this.dataset.contentBelow === "true",
			showNav: this.dataset.showNav === 'true',
			showPagination: this.dataset.showPagination === 'true',
			autorotateSpeed: parseInt(this.dataset.autorotateSpeed) * 1000,
			slidesImage: this.elements.images.querySelector(".f-slideshow__image"),
		};
		
		this.init()
		this.matchMedia()
  }

  init() {
		setTimeout(() => {
			this.flickityImages = new Flickity(this.elements.images, {
				accessibility: false,
				autoPlay: this.settings.autorotate
					? this.settings.autorotateSpeed
					: false,
				pageDots: this.settings.showPagination,
				prevNextButtons: this.settings.showNav,
				draggable: true,
				sync: this.elements.contents,
				wrapAround: true,
				setGallerySize: false,
			});
	
			this.flickityContents = new Flickity(this.elements.contents, {
				accessibility: false,
				prevNextButtons: this.settings.showNav,
				pageDots: this.settings.showPagination,
				sync: this.elements.images,
				adaptiveHeight: true,
				wrapAround: true,
				draggable: true,
				setGallerySize: this.settings.contentBelow ? true : false,
			});


            let self = this;
            self.flickityContents.on('change', function( index ) {
              self.flickityImages.select(index);
            })
		}, 0);
      }

	unload() {
		if (this.flickityImages && typeof this.flickityImages.destroy === 'function') {
      this.flickityImages.destroy();
    }
    if (this.flickityContents && typeof this.flickityContents.destroy === 'function') {
      this.flickityContents.destroy();
    }
	}

	matchMedia() {
		if (FoxThemeSettings.isMobile) {
			this.unload();
			this.init();
		}
		document.addEventListener("matchMobile", () => {
			console.log('match')
			this.unload();
      this.init();
		});
		document.addEventListener("unmatchMobile", () => {
			console.log('unmatch')
			this.unload();
      this.init();
		});
	}

	attributeChangedCallback(name, oldValue, newValue) {
		if (newValue != oldValue) {
			this.unload()
			this.init()
		}
	}
}
customElements.define("f-slideshow-component", FSlideshow);

class DropdownMenu extends HTMLElement {
  constructor() {
    super();

    this.classes = {
      hover: 'f-is-hover',
      active: 'f-is-active',
      animate: 'show-from-bottom',
    };
    this.selectors = {
      header: 'shopify-section-f-header',
      background: '.f-header-background',
      topMenuItem: '.f-header__menu-item--top',
      menus: 'f-dropdown-menu, f-mega-menu',
      wrapper: '.f-list-menu',
      childAnimate: '.f-list-menu-dropdown > .f-list-menu'
    };
    this.timeout;

    this.addEventListener('focusin', this.handleMouseover.bind(this));
    this.addEventListener('mouseenter', this.handleMouseover.bind(this));
  }

  handleMouseover() {
    if (this.classList.contains(this.classes.active)) return;

    this.bindEvent();
    this.removeClasses();
    this.addClasses();
    this.resetBackground();
    this.animateMenu();
  }

  handleMouseleave() {
    if (!this.header) return;

    this.reset();
    this.resetBackground();

    this.header.classList.remove(this.classes.hover);
    this.header.classList.remove(this.classes.active);
    this.removeEventListener('mouseleave', this.onHeaderMouseLeaveEvent);
  }

  bindEvent() {
    this.onHeaderMouseLeaveEvent = this.onHeaderMouseLeaveEvent || this.handleMouseleave.bind(this);

    this.header = this.header || document.getElementById(this.selectors.header);

    this.addEventListener('mouseleave', this.onHeaderMouseLeaveEvent);
  }

  addClasses() {
    const isTopLevel = this.querySelector(this.selectors.topMenuItem);

    let delay = 0;
    if (isTopLevel && !this.isHover()) {
      delay = 150;

      if (this.closest('.header--top-center') || this.closest('.header--top-left')) {
        delay = 200;
      }
    }
    this.timeout = setTimeout(() => {
      if (this.isHover()) {
        this.classList.add(this.classes.active);
      }
    }, delay);

    this.header.classList.add(this.classes.hover);
  }

  removeClasses() {
    const menus = this.header.querySelectorAll(this.selectors.menus);

    menus.forEach((menu) => {
      let found = false;
      const childMenus = menu.querySelectorAll('f-dropdown-menu');
      childMenus.forEach((element) => {
        if (element === this) {
          found = true;
          return;
        }
      });

      if (!found) menu.reset();
    });
  }

  isHover() {
    return this.header.classList.contains(this.classes.hover);
  }

  reset() {
    this.classList.remove(this.classes.active);

    const childAnimate =  this.querySelector(this.selectors.childAnimate);
    if (childAnimate) childAnimate.classList.remove(this.classes.animate);

    clearTimeout(this.timeout);
  }

  resetBackground() {
    const background = this.header.querySelector(this.selectors.background);
    background.classList.remove(this.classes.active);
  }

  animateMenu() {
    const childAnimate =  this.querySelector(this.selectors.childAnimate);
    if (childAnimate) {
      setTimeout(() => {
        childAnimate.classList.add(this.classes.animate);
      }, 150);
    }
  }

  close() {
    this.handleMouseleave();
  }
}
customElements.define('f-dropdown-menu', DropdownMenu);

class MegaMenu extends HTMLElement {
  constructor() {
    super();

    this.classes = {
      hover: 'f-is-hover',
      active: 'f-is-active',
      animate: 'show-from-bottom',
    };
    this.selectors = {
      header: 'shopify-section-f-header',
      background: '.f-header-background',
      dropdown: '.f-list-menu-dropdown',
      menus: 'f-dropdown-menu, f-mega-menu',
      wrapper: '.f-list-menu',
      childAnimate: '.f-mega-menu__item, .f-mega-menu__promo'
    };
    this.timeout = [];

    this.addEventListener('focusin', this.handleMouseover.bind(this));
    this.addEventListener('mouseenter', this.handleMouseover.bind(this));
  }

  handleMouseover() {
    if (this.classList.contains(this.classes.active)) return;
    
    this.bindEvent();
    this.removeClasses();
    this.addClasses();
    this.showSublist();
  }

  handleMouseleave() {
    if (!this.header) return;

    this.reset();
    this.resetBackground();

    this.header.classList.remove(this.classes.hover);
    this.wrapper.removeEventListener('mouseleave', this.onHeaderMouseLeaveEvent);
  }

  bindEvent() {
    this.onHeaderMouseLeaveEvent = this.onHeaderMouseLeaveEvent || this.handleMouseleave.bind(this);
    
    this.header = this.header || document.getElementById(this.selectors.header);

    this.wrapper = this.closest(this.selectors.wrapper)
    this.wrapper.addEventListener('mouseleave', this.onHeaderMouseLeaveEvent);
  }

  showSublist() {
    const dropdown = this.querySelector(this.selectors.dropdown);
    const background = this.header.querySelector(this.selectors.background);
    background.style.height = this.header.clientHeight + dropdown.clientHeight + 'px';
    background.classList.add(this.classes.active);
  }

  addClasses() {
    this.classList.add(this.classes.active);

    const childAnimate = this.querySelectorAll(this.selectors.childAnimate);
    const delay = childAnimate.length > 5 ? 75 : 150;
    childAnimate.forEach((element, index) => {
      const timeout = setTimeout(() => {
        element.classList.add(this.classes.animate);
      }, (delay * index) + 100);
      
      this.timeout.push(timeout);
    });
    
    this.header.classList.add(this.classes.hover);
  }

  removeClasses() {
    const menus = this.header.querySelectorAll(this.selectors.menus);
    menus.forEach((menu) => {
      menu.reset();
    });
  }

  reset() {
    this.classList.remove(this.classes.active);

    const childAnimate = this.querySelectorAll(this.selectors.childAnimate);
    childAnimate.forEach((element) => {
      element.classList.remove(this.classes.animate);
    });
    this.timeout.forEach((timeout) => {
      clearTimeout(timeout);
    });
  }

  resetBackground() {
    const background = this.header.querySelector(this.selectors.background);
    background.classList.remove(this.classes.active);
  }

  close() {
    this.handleMouseleave();
  }
}
customElements.define('f-mega-menu', MegaMenu);

class DrawerMenu extends HTMLElement {
  constructor() {
    super()
    
    this.selectors = {
      toggleDrawer: '.f-header__icon--menu',
      toggleMenuItem: ['.f-menu-drawer__icon-toggle'],
      menuDrawer: '.f-menu-drawer',
      subMenuWrapper: '.f-menu-drawer__submenu'
    }

    this.domNodes = queryDomNodes(this.selectors, this)
    
    const { toggleDrawer, toggleMenuItem, menuDrawer, subMenuWrapper } = this.domNodes

		document.addEventListener("matchMobile", () => {
		});
		document.addEventListener("unmatchMobile", () => {
			console.log('unmatch')
			document.body.classList.remove('f-overflow-hidden')
      this.classList.remove('f-is-open')
		});

    toggleDrawer.addEventListener('click', () => {
      this.classList.toggle('f-is-open')
      document.body.classList.toggle('f-overflow-hidden')
    })

    toggleMenuItem.forEach(item => {
      const subMenu = item.nextElementSibling
      item.addEventListener('click', () => {
        item.classList.toggle('f-is-open')
        if (subMenu.classList.contains('f-is-open')) {
          subMenu.classList.remove('f-is-open')
          subMenu.style.removeProperty('display')
        } else {
          subMenu.classList.add('f-is-open')
          subMenu.style.display = 'block'
          const subMenuHeight = subMenu.scrollHeight
          subMenu.style.overflow = 'hidden'
          subMenu.style.height = subMenuHeight + 'px'
          setTimeout(() => {
            subMenu.style.removeProperty('height')
            subMenu.style.removeProperty('overflow')
          }, 500) 
        }
      })
    })
  }
}
customElements.define('f-header-drawer', DrawerMenu);

class Tabs extends HTMLElement {
  constructor() {
    super()
    this.selectors = {
      tabHeader: '[role="tablist"]',
      tabPanels: ['[role="tabpanel"]'],
      tabNavs: ['[role="tab"]'],
      tabSelect: 'tab-selector',
      tabNavPosition: '.f-tabs__nav--position',
      tabNavGroup: '.f-tabs__header-group'
    }
    this.domNodes = queryDomNodes(this.selectors, this)

    this.Collapsible = null
    this.selectedIndex = 0
    this.selectedTab = this.domNodes.tabPanels[this.selectedIndex]

    this.init()
    this.setActiveTab(0)

    this.tabChange = new CustomEvent('tabChange', {
      bubbles: true,
      detail: {selectedTab: this.selectedTab}
    })
  }

  connectedCallback() {
    this.setActiveTab(0)
  }

  init = () => {
    this.domNodes.tabNavs.forEach(tab => {
      tab.addEventListener('click', e => {
        e.preventDefault()
        const index = Number(e.target?.dataset?.index)
        this.setActiveTab(index)
      })
    })

    this.domNodes.tabHeader?.addEventListener('keydown', this.handleKeyDown.bind(this))
    this.setAccessible()
  }

  setLineStyle = (tab) => {
    let navGroupWidth = this.domNodes.tabNavGroup?.clientWidth
    let scale = tab.clientWidth / navGroupWidth
    let translate = tab.offsetLeft / navGroupWidth / scale

    this.style.setProperty('--scale', scale)
    this.style.setProperty('--translate', `${translate * 100}%`)
  }

  setActiveTab = (tabIndex) => {
    const {tabNavs, tabPanels, tabSelect, tabNavPosition} = this.domNodes
    if (tabIndex !== -1) {
      const newHeader = tabNavs?.[tabIndex]
      const newTab = tabPanels?.[tabIndex]
      this.setAttribute('data-selected', tabIndex)
      tabNavPosition.classList.add('is-initialized')

      tabNavs.forEach(nav => nav.setAttribute('aria-selected', false))
      this.selectedTab?.setAttribute('hidden', '')

      newHeader?.setAttribute('aria-selected', true)
      newTab?.removeAttribute('hidden')
      this.setLineStyle(newHeader)

      this.selectedIndex = tabIndex
      this.selectedTab = newTab

      this.dispatchEvent(new CustomEvent('tabChange', {
        bubbles: true,
        detail: {selectedIndex: tabIndex, selectedTab: newTab}
      }))

      if (this.isMobile?.matches && this.Collapsible) {
        this.Collapsible.toggle(this.Collapsible.els[tabIndex])
      }

      if (tabSelect) {
        tabSelect.querySelector('select').value = tabIndex
      }
    }
  }

  setAccessible() {
    const {tabNavs, tabPanels} = this.domNodes
    tabNavs.forEach((tab, index) => {
      if (tab.id) tabPanels[index].setAttribute('aria-labelledby', tab.id)
      tab.setAttribute('aria-selected', index === 0)
      tab.setAttribute('data-index', index)
      if (index !== 0) {
        tab.setAttribute('tabindex', -1)
      }
    })
    tabPanels.forEach((panel, index) => {
      if (panel.id) tabNavs[index].setAttribute('aria-controls', panel.id)
      panel.setAttribute('tabindex', 0)
    })
  }

  handleKeyDown(e) {
    const {tabNavs} = this.domNodes
    if (e.keyCode === 39 || e.keyCode === 37) {
      tabNavs[this.selectedIndex].setAttribute('tabindex', -1)
      if (e.keyCode === 39) {
        this.selectedIndex++
        // If we're at the end, go to the start
        if (this.selectedIndex >= tabNavs.length) {
          this.selectedIndex = 0
        }
        // Move left
      } else if (e.keyCode === 37) {
        this.selectedIndex--
        // If we're at the start, move to the end
        if (this.selectedIndex < 0) {
          this.selectedIndex = tabNavs.length - 1
        }
      }

      tabNavs[this.selectedIndex].setAttribute('tabindex', 0)
      tabNavs[this.selectedIndex].focus()
    }
  }

  getSelected() {
    return {
      index: this.selectedIndex,
      element: this.selectedTab
    }
  }
}
customElements.define('f-tabs-component', Tabs)

class CollapsibleTab extends HTMLElement {
  constructor() {
    super()
  }

  connectedCallback() {
    this.init()
  }

  disconnectedCallback() {
    this.destroy()
  }

  init = () => {
    const destroy = this.dataset.destroy === 'true'
    if (destroy) return

    this.setDefaultData();
    this.attachEvents()

    if (this.getAttribute('open') === 'true') {
      this.selected = true
      this.classList.add(this.expandedClass)
      this.setExpandedAria()
    } else {
      this.content.style.height = this.collapsedHeight
      this.classList.add(this.collapsedClass)
      this.setCollapsedAria()
    }
    this.content.removeAttribute('hidden')
  }

  transitionendEventName = () => {
    let i,
      el = document.createElement('div'),
      transitions = {
        'transition': 'transitionend',
        'OTransition': 'otransitionend',
        'MozTransition': 'transitionend',
        'WebkitTransition': 'webkitTransitionEnd'
      }

    for (i in transitions) {
      if (transitions.hasOwnProperty(i) && el.style[i] !== undefined) {
        return transitions[i]
      }
    }
  }

  expand = () => {
    const resetHeight = (ev) => {
      if (ev.target !== this.content) return
      this.content.removeEventListener(this.transitionendevent, bindEvent)

      if (!this.isOpen) return

      requestAnimationFrame(() => {
        this.content.style.transition = '0'
        this.content.style.height = 'auto'

        requestAnimationFrame(() => {
          this.content.style.height = null
          this.content.style.transition = null

          this.setExpandedAria()
          this.classList.add(this.expandedClass)
          this.trySetTabIndex(this.content, 0)

          this.fire("tabOpened")
        })
      })
    }

    const bindEvent = resetHeight.bind(this)
    this.content.addEventListener(this.transitionendevent, bindEvent)

    this.isOpen = true
    this.classList.remove(this.collapsedClass)
    this.content.style.height = this.content.scrollHeight + "px"
  }

  collapse = () => {
    const endTransition = (ev) => {
      if (ev.target !== this.content) return
      this.content.removeEventListener(this.transitionendevent, bindEvent)

      if (this.isOpen) return

      this.fire("elementClosed")
      this.setCollapsedAria()
      this.classList.add(this.collapsedClass)
      this.trySetTabIndex(this.content, -1)
    }

    const bindEvent = endTransition.bind(this)
    this.content.addEventListener(this.transitionendevent, bindEvent)

    this.isOpen = false
    this.classList.remove(this.expandedClass)

    requestAnimationFrame(() => {
      this.content.style.transition = '0'
      this.content.style.height = this.content.scrollHeight + "px"


      requestAnimationFrame(() => {
        this.content.style.transition = null
        this.content.style.height = this.collapsedHeight
      })
    })
  }

  open = () => {
    this.selected = true
    this.fire("elementSelected")
    this.expand()
    this.setAttribute('open', true)
    console.log('elementSelected')
  }

  close = () => {
    console.log('elementUnselected')
    this.selected = false
    this.fire("elementUnselected")
    this.collapse()
    this.removeAttribute('open')
  }

  toggle = (event) => {
    event?.preventDefault()
    if (this.selected) {
      this.close()
    } else {
      this.open()

      if (this.oneAtATime) {
        const allItems = document.querySelectorAll('collapsible-tab')
        const parent = this.closest('[data-first-level]')
        if (allItems.length) {
          allItems.forEach(item => {
            if (item !== this && item.selected && parent !== item) {
              item.close()
            }
          })
        }
      }
    }
  }

  trySetTabIndex(el, index) {
    const tappableElements = el.querySelectorAll(this.defaultElements)
    if (tappableElements) {
      tappableElements.forEach(e => {
        e.setAttribute('tabindex', index)
      })
    }
  }

  setExpandedAria = () => {
    this.trigger.setAttribute('aria-expanded', 'true')
    this.content.setAttribute('aria-hidden', 'false')
  }

  setCollapsedAria = (el) => {
    this.trigger.setAttribute('aria-expanded', 'false')
    this.content.setAttribute('aria-hidden', 'true')
  }

  attachEvents = () => {
    this.trigger.addEventListener("click", event => this.toggle(event))
  }

  setDefaultData = () => {
    this.events = {
      'elementSelected': [],
      'tabOpened': [],
      'elementUnselected': [],
      'elementClosed': []
    }
    this.transitionendevent = this.transitionendEventName()
    this.expandedClass = "is-expanded"
    this.collapsedClass = "is-collapsed"
    this.trigger = this.querySelector('[data-trigger]')
    this.content = this.querySelector('[data-content]')
    this.collapsedHeight = '0px'
    this.defaultElements = ['a', 'button', 'input:not(.focus-none)', '[data-trigger]']
    this.oneAtATime = true
    if (this.dataset.oneOpen) {
      this.oneAtATime = this.dataset.oneOpen === 'true'
    }
  }

  fire = (eventName) => {
    let callbacks = this.events[eventName]
    for (let i = 0; i < callbacks?.length; i++) {
      callbacks[i](this)
    }
  }

  on = (eventName, cb) => {
    if (!this.events[eventName]) return
    this.events[eventName].push(cb)
  }

  destroy = () => {
    this.trigger.removeEventListener("click", event => this.toggle(event))
    this.content.removeAttribute('aria-hidden')
    this.content.style.height = 'auto'
    this.classList.remove(this.expandedClass, this.collapsedClass)
    this.removeAttribute('open')
  }
}
customElements.define('f-collapsible-tab', CollapsibleTab)